import React, { useState, useEffect } from "react";
import "./style.css";

const RADIUS = 16;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

const PloomScrollTop = () => {
  const [progress, setProgress] = useState(0);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      const pct = docHeight > 0 ? scrollTop / docHeight : 0;
      setProgress(pct);
      setVisible(scrollTop > 300);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const offset = CIRCUMFERENCE - progress * CIRCUMFERENCE;

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (!visible) return null;

  return (
    <button
      className="new-scroll-top"
      onClick={handleClick}
      aria-label="Scroll to top"
    >
      <svg
        className="new-scroll-top__ring"
        width="44"
        height="44"
        viewBox="0 0 44 44"
      >
        {/* Track */}
        <circle
          cx="22"
          cy="22"
          r={RADIUS}
          fill="none"
          stroke="rgba(144,77,113,0.15)"
          strokeWidth="4"
        />
        {/* Progress arc */}
        <circle
          cx="22"
          cy="22"
          r={RADIUS}
          fill="none"
          stroke="#904d71"
          strokeWidth="4"
          strokeLinecap="round"
          strokeDasharray={CIRCUMFERENCE}
          strokeDashoffset={offset}
          transform="rotate(-90 22 22)"
        />
      </svg>
      <svg
        className="new-scroll-top__arrow"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M18 15l-6-6-6 6" />
      </svg>
    </button>
  );
};

export default PloomScrollTop;
